import { cn } from './cn';
import { formatBillionCurrency } from './format';

export const projectImages = [
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=240&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=240&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=240&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?q=80&w=240&auto=format&fit=crop',
];

export const detailProjectImage = 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=900&auto=format&fit=crop';

export function formatMoney(value?: number | string | null) {
  return formatBillionCurrency(value);
}

export function formatDate(value?: string | null) {
  if (!value) return '--/--/----';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '--/--/----';
  return date.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function projectTypeLabel(type?: string | null) {
  if (type === 'maintenance') return 'Bảo dưỡng';
  if (type === 'infrastructure') return 'Hạ tầng';
  return 'Thi công';
}

export function statusLabel(status?: string | null) {
  if (status === 'completed') return 'Hoàn thành';
  if (status === 'planning') return 'Chuẩn bị';
  if (status === 'on_hold') return 'Tạm dừng';
  return 'Đang thực hiện';
}

export function statusTone(status?: string | null) {
  if (status === 'completed') return 'bg-blue-50 text-blue-700';
  if (status === 'planning') return 'bg-amber-50 text-amber-700';
  if (status === 'on_hold') return 'bg-orange-50 text-orange-700';
  return 'bg-emerald-50 text-emerald-700';
}

export function statusClass(status?: string | null) {
  return cn('rounded-md px-2 py-1 text-xs font-semibold', statusTone(status));
}

export function typeTone(type?: string | null) {
  if (type === 'maintenance') return 'bg-emerald-50 text-emerald-700';
  return 'bg-blue-50 text-blue-700';
}

export function progressTone(progress: number) {
  if (progress < 25) return 'bg-red-500';
  if (progress < 55) return 'bg-amber-500';
  return 'bg-emerald-700';
}

export function progressClass(progress: number) {
  if (progress >= 90) return 'bg-emerald-700';
  if (progress >= 45) return 'bg-blue-600';
  if (progress > 0) return 'bg-amber-500';
  return 'bg-slate-300';
}

export function fileTone(type?: string | null) {
  const lower = String(type || '').toLowerCase();
  if (lower.includes('pdf')) return 'bg-red-50 text-red-600';
  if (lower.includes('dwg')) return 'bg-blue-50 text-blue-600';
  if (lower.includes('xls')) return 'bg-emerald-50 text-emerald-600';
  if (lower.includes('doc')) return 'bg-sky-50 text-sky-600';
  return 'bg-amber-50 text-amber-600';
}

export function fallbackProject(index: number, project?: { thumbnail_url?: string | null; thumbnailUrl?: string | null }) {
  const url = project?.thumbnail_url || project?.thumbnailUrl;
  if (url) return url;
  return projectImages[index % projectImages.length];
}
